<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-02 10:16:14
 * @FilePath: \YunYin_admin\src\views\Setting\RoleManagement\components\MemberList.vue
-->
<template>
  <div class="member-list">
    <el-dialog
      class="dialog-bg dialog-member"
      :title="`${curRoleDetail.roleName} 账号管理`"
      :visible.sync="dialogMemberVisible"
      :before-close="close"
      width="60%"
    >
      <div class="top-filter">
        <el-form
          ref="filterFormMember"
          :inline="true"
          :model="filterFormMember"
          class="filter-form"
        >
          <el-form-item prop="fullName">
            <el-input
              v-model="filterFormMember.fullName"
              placeholder="请输入登录账号或员工姓名"
              @keyup.enter.native="handleFilterMember"
              style="width: 260px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterMember"
              >查询</el-button
            >
            <el-button
              type="primary"
              plain
              @click="handleResetFilterMember('filterFormMember')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="accounts"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="人员姓名"
          min-width="10%"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.fullName }}
            <span v-if="scope.row.isOneself" class="tag"
              >（是本人）</span
            ></template
          >
        </el-table-column>
        <el-table-column
          prop="loginName"
          label="登录账号"
          min-width="12%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="12%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="角色权限"
          min-width="20%"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.roleNames }}
          </template>
        </el-table-column>
        <el-table-column
          prop="created"
          label="新增时间"
          min-width="15%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="10%"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleRemoveRole(scope.row)"
              :disabled="scope.row.isOneself"
              >移除角色
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MemberList",
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      filterFormMember: {
        fullName: "",
      },
      accounts: [], // 账号（角色成员）
    };
  },
  props: {
    dialogMemberVisible: {
      type: Boolean,
      default: () => false,
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    close(type) {
      this.$emit("close", "dialogMemberVisible", type);
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:34
     * @param {*} formName 表单ref名称
     */
    handleResetFilterMember(formName) {
      this.$refs[formName].resetFields();
      this.getAccountList();
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAccountList();
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:09
     */
    handleFilterMember() {
      this.getAccountList();
    },
    /**
     * @descripttion: 获取账号列表
     * @Author: juanjuanhui
     * @Date: 2022-02-23 11:41:48
     */
    getAccountList() {
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize };
      this.filterFormMember.roleId = this.curRoleDetail.id;
      Object.assign(params, params, this.filterFormMember);
      this.$http.account
        .getManageAccount({ ...params, systemType: this.systemType })
        .then((res) => {
          let { recordTotal, content: accounts } = res.data;
          this.pagination.recordTotal = recordTotal;
          this.accounts = accounts;
        });
    },
    /**
     * @descripttion: 移除角色
     * @Author: juanjuanhui
     * @Date: 2022-02-19 16:30:14
     * @param {*} item 当前数据项
     */
    handleRemoveRole(value) {
      this.$emit("setData", { label: "curAccountDetail", value });
      this.close("dialogRemoveRoleVisible");
    },
  },
  created() {},
  mounted() {
    this.getAccountList();
  },
};
</script>
<style lang="scss" scoped>
.member-list {
}
</style>

